export const State = { AVAILABLE: 0, PROCESSED: 1, ABORT: 2 }